(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");
  document.documentElement.classList.add("js");
  document.body.classList.add("has-maison-js");
  if (window.Shopify?.designMode) document.body.classList.add("is-design-mode");

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const money = (cents) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format((Number(cents) || 0) / 100);
  const escapeHtml = (value) => String(value ?? "").replace(/[&<>'"]/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[character]);

  let activeLayerTrigger = null;
  let searchAbortController = null;

  function refreshIcons() {
    const iconRuntime = window.lucide || (window.exports?.createIcons ? window.exports : null);
    if (!iconRuntime || typeof iconRuntime.createIcons !== "function") return false;
    try {
      iconRuntime.createIcons();
      document.body.classList.add("has-maison-icons");
      return true;
    } catch {
      document.body.classList.remove("has-maison-icons");
      return false;
    }
  }

  function getOpenLayer() {
    return $$('[data-drawer], [data-panel]').find((element) => !element.hidden) || null;
  }

  function getFocusableElements(layer) {
    return $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', layer)
      .filter((element) => element.getClientRects().length > 0 && element.getAttribute("aria-hidden") !== "true");
  }

  function closeLayers(restoreFocus = true) {
    $$('[data-drawer], [data-panel]').forEach((element) => { element.hidden = true; });
    $$('[data-drawer-open], [data-panel-open]').forEach((element) => element.setAttribute("aria-expanded", "false"));
    const overlay = $('[data-overlay]');
    if (overlay) overlay.hidden = true;
    document.body.classList.remove("is-locked");
    if (restoreFocus && activeLayerTrigger?.isConnected) activeLayerTrigger.focus({ preventScroll: true });
    activeLayerTrigger = null;
  }

  function openLayer(selector, trigger = null) {
    closeLayers(false);
    const layer = $(selector);
    const overlay = $('[data-overlay]');
    if (!layer || !overlay) return;
    activeLayerTrigger = trigger instanceof HTMLElement ? trigger : document.activeElement;
    layer.hidden = false;
    overlay.hidden = false;
    document.body.classList.add("is-locked");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    window.requestAnimationFrame(() => {
      const focusTarget = $('[data-predictive-search]', layer) || getFocusableElements(layer)[0];
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      if (getOpenLayer()) closeLayers();
      return;
    }
    if (event.key !== "Tab") return;
    const layer = getOpenLayer();
    if (!layer) return;
    const focusable = getFocusableElements(layer);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  function rotateAnnouncement(button, direction) {
    const container = button.closest('[data-announcements]');
    if (!container) return;
    const announcements = $$('[data-announcement]', container);
    if (!announcements.length) return;
    const visibleIndex = announcements.findIndex((item) => !item.hidden);
    const currentIndex = visibleIndex >= 0 ? visibleIndex : 0;
    const nextIndex = (currentIndex + direction + announcements.length) % announcements.length;
    announcements.forEach((item, itemIndex) => { item.hidden = itemIndex !== nextIndex; });
  }

  async function copyCode(button) {
    const code = button.dataset.copyCode || "";
    try {
      await navigator.clipboard.writeText(code);
      const label = $('[data-copy-label]', button);
      const defaultLabel = button.dataset.copyDefault || "Copy code";
      if (label) label.textContent = button.dataset.copySuccess || "Copied";
      button.dataset.copied = "true";
      window.setTimeout(() => {
        if (!button.isConnected) return;
        if (label) label.textContent = defaultLabel;
        delete button.dataset.copied;
      }, 1800);
    } catch {
      window.prompt("Copy offer code", code);
    }
  }

  function scrollReviews(button) {
    const section = button.closest('.proof-section');
    const rail = $('[data-review-rail]', section || document);
    if (!rail) return;
    const card = $("figure", rail);
    const step = (card?.getBoundingClientRect().width || rail.clientWidth * 0.8) + 16;
    rail.scrollBy({ left: Number(button.dataset.reviewScroll) * step, behavior: "smooth" });
  }

  function setActiveProductMedia(productRoot, mediaId) {
    const mediaItems = $$('[data-product-media]', productRoot);
    if (!mediaItems.length) return;
    const currentMedia = mediaItems.find((item) => item.classList.contains("is-active"));
    const selectedMedia = mediaId ? mediaItems.find((item) => item.dataset.mediaId === String(mediaId)) : null;
    const activeMedia = selectedMedia || currentMedia || mediaItems[0];
    mediaItems.forEach((item) => item.classList.toggle("is-active", item === activeMedia));
    $$('[data-media-button]', productRoot).forEach((button) => {
      const selected = button.dataset.mediaId === activeMedia.dataset.mediaId;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", String(selected));
    });
  }

  function syncVariantButtons(productRoot, variantId) {
    $$('[data-variant-button]', productRoot).forEach((button) => {
      const selected = button.dataset.variantId === String(variantId);
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", String(selected));
    });
  }

  function updateVariant(variantSelect, updateUrl = true) {
    const productRoot = variantSelect.closest('.product-detail') || document;
    const variantData = $('[data-product-json]', productRoot);
    if (!variantData) return;
    let variants = [];
    try { variants = JSON.parse(variantData.textContent || "[]"); } catch { variants = []; }
    const variant = variants.find((item) => String(item.id) === variantSelect.value);
    const price = $('[data-product-price]', productRoot);
    const addButton = $('[data-add-to-cart]', productRoot);
    if (variant && price) price.innerHTML = `<span>${money(variant.price)}</span>${variant.compare_at_price > variant.price ? `<del>${money(variant.compare_at_price)}</del>` : ""}`;
    if (variant && addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? addButton.dataset.addLabel : addButton.dataset.unavailableLabel;
    }
    if (!variant) return;
    syncVariantButtons(productRoot, variant.id);
    const selectedOption = variantSelect.selectedOptions[0];
    setActiveProductMedia(productRoot, selectedOption?.dataset.mediaId || variant.featured_media?.id);
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variantSelect.value);
      window.history.replaceState({}, "", url);
    }
  }

  function initializeVariantPickers(root = document) {
    document.body.classList.add("has-maison-js");
    $$('[data-variant-select]', root).forEach((variantSelect) => {
      variantSelect.setAttribute("aria-hidden", "true");
      variantSelect.tabIndex = -1;
      updateVariant(variantSelect, false);
    });
  }

  async function getCart() {
    const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    if (!response.ok) throw new Error("Cart unavailable");
    return response.json();
  }

  function renderCart(cart) {
    const drawer = $('[data-drawer="bag"]');
    $$('[data-cart-count]').forEach((badge) => {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    });
    const triggerLabel = cart.item_count === 1
      ? drawer?.dataset.cartLabelOne || "Shopping bag with 1 item"
      : (drawer?.dataset.cartLabelOther || "Shopping bag with __COUNT__ items").replaceAll("__COUNT__", String(cart.item_count));
    $$('[data-drawer-open="bag"]').forEach((button) => button.setAttribute("aria-label", triggerLabel));
    const heading = $(".drawer__header span", drawer || document);
    const headingLabel = (drawer?.dataset.cartBagTemplate || "Bag (__COUNT__)").replaceAll("__COUNT__", String(cart.item_count));
    if (heading) heading.textContent = headingLabel;
    const target = $('[data-cart-drawer-content]');
    if (!target) return;
    const labels = {
      empty: drawer?.dataset.cartEmpty || "Your bag is empty",
      discover: drawer?.dataset.cartDiscover || "Discover the collection",
      subtotal: drawer?.dataset.cartSubtotal || "Subtotal",
      view: drawer?.dataset.cartView || "View bag",
      checkout: drawer?.dataset.cartCheckout || "Checkout",
      decrease: drawer?.dataset.cartDecrease || "Decrease quantity",
      increase: drawer?.dataset.cartIncrease || "Increase quantity",
      remove: drawer?.dataset.cartRemove || "Remove"
    };
    if (!cart.item_count) {
      target.innerHTML = `<div class="bag-content"><div class="bag-empty"><i data-lucide="shopping-bag" aria-hidden="true"></i><span class="icon-fallback icon-fallback--word" aria-hidden="true">Bag</span><h2>${escapeHtml(labels.empty)}</h2><a class="button button--outline" href="/collections/frontpage">${escapeHtml(labels.discover)}</a></div></div><p class="bag-status" data-cart-status role="status" aria-live="polite"></p>`;
      refreshIcons();
      return;
    }
    const lines = cart.items.map((item, index) => {
      const variant = item.variant_title && item.variant_title !== "Default Title" ? `<span class="bag-line__variant">${escapeHtml(item.variant_title)}</span>` : "";
      return `<div class="bag-line" data-line="${index + 1}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : ""}<div><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>${variant}<span>${money(item.final_line_price ?? item.final_price)}</span><div class="bag-line__controls"><div class="quantity"><button type="button" data-cart-change="-1" aria-label="${escapeHtml(labels.decrease)}"><i data-lucide="minus" aria-hidden="true"></i><span class="icon-fallback" aria-hidden="true">-</span></button><span>${item.quantity}</span><button type="button" data-cart-change="1" aria-label="${escapeHtml(labels.increase)}"><i data-lucide="plus" aria-hidden="true"></i><span class="icon-fallback" aria-hidden="true">+</span></button></div><button class="bag-line__remove" type="button" data-cart-remove>${escapeHtml(labels.remove)}</button></div></div></div>`;
    }).join("");
    const offerTemplate = $('[data-bag-offer-template]', drawer || document);
    const offerMarkup = offerTemplate?.innerHTML || "";
    target.innerHTML = `<div class="bag-content">${lines}</div><p class="bag-status" data-cart-status role="status" aria-live="polite"></p><div class="bag-footer">${offerMarkup}<div class="bag-footer__subtotal"><span>${escapeHtml(labels.subtotal)}</span><strong>${money(cart.total_price)}</strong></div><a class="button button--outline button--wide" href="/cart">${escapeHtml(labels.view)}</a><form class="bag-footer__checkout" action="/cart" method="post"><button class="button button--dark button--wide" type="submit" name="checkout">${escapeHtml(labels.checkout)}</button></form></div>`;
    refreshIcons();
  }

  function setCartStatus(message, isError = false) {
    const status = $('[data-cart-status]');
    if (!status) return;
    status.textContent = message;
    status.classList.toggle("is-error", isError);
  }

  function applyDiscountEntry(entry) {
    const input = $('[data-discount-code]', entry);
    const status = $('[data-discount-status]', entry);
    const code = input?.value.trim() || "";
    if (!code) {
      if (status) status.textContent = entry.dataset.discountEmpty;
      input?.focus();
      return;
    }
    if (status) status.textContent = entry.dataset.discountApplying;
    const redirect = entry.dataset.discountRedirect || "/checkout";
    const encodedCode = encodeURIComponent(encodeURIComponent(code));
    window.location.assign(`/discount/${encodedCode}?redirect=${encodeURIComponent(redirect)}`);
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest?.('[data-discount-apply]');
    if (!button) return;
    event.preventDefault();
    const entry = button.closest('[data-discount-entry]');
    if (entry) applyDiscountEntry(entry);
  });

  document.addEventListener("keydown", (event) => {
    const input = event.target.closest?.('[data-discount-code]');
    if (!input || event.key !== "Enter") return;
    event.preventDefault();
    const entry = input.closest('[data-discount-entry]');
    if (entry) applyDiscountEntry(entry);
  });

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest("form[action*='/cart/add']");
    if (!form) return;
    event.preventDefault();
    const button = $('[data-add-to-cart]', form);
    const status = $('[data-product-status]', form);
    if (button) button.disabled = true;
    if (status) status.textContent = "Adding to bag";
    try {
      const response = await fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
      if (!response.ok) throw new Error("Unable to add this selection");
      renderCart(await getCart());
      if (status) status.textContent = "Added to bag";
      openLayer('[data-drawer="bag"]');
    } catch (error) {
      if (status) status.textContent = error.message || "Unable to add this selection";
    } finally {
      if (button) button.disabled = false;
    }
  });

  document.addEventListener("click", async (event) => {
    const changeButton = event.target.closest('[data-cart-change], [data-cart-remove]');
    if (!changeButton) return;
    const line = changeButton.closest('[data-line]');
    if (!line) return;
    changeButton.disabled = true;
    setCartStatus("Updating bag");
    try {
      const cart = await getCart();
      const item = cart.items[Number(line.dataset.line) - 1];
      if (!item) return;
      const quantity = changeButton.matches('[data-cart-remove]') ? 0 : Math.max(0, item.quantity + Number(changeButton.dataset.cartChange));
      const response = await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line: Number(line.dataset.line), quantity }) });
      if (!response.ok) throw new Error("Unable to update bag");
      renderCart(await response.json());
      setCartStatus(quantity === 0 ? "Removed from bag" : "Bag updated");
    } catch (error) {
      setCartStatus(error.message || "Unable to update bag", true);
      changeButton.disabled = false;
    }
  });

  const searchTimers = new WeakMap();
  document.addEventListener("input", (event) => {
    const input = event.target.closest?.('[data-predictive-search]');
    if (!input) return;
    const query = input.value.trim();
    const drawer = input.closest('[data-drawer="search"]');
    const target = $('[data-predictive-results]', drawer || document);
    window.clearTimeout(searchTimers.get(input));
    searchAbortController?.abort();
    if (!target || query.length < 2) {
      if (target) { target.hidden = true; target.innerHTML = ""; }
      return;
    }
    target.hidden = false;
    target.setAttribute("aria-busy", "true");
    target.innerHTML = "<p>Searching the collection</p>";
    const timer = window.setTimeout(async () => {
      searchAbortController = new AbortController();
      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`, { headers: { Accept: "application/json" }, signal: searchAbortController.signal });
        if (!response.ok) throw new Error("Search unavailable");
        const payload = await response.json();
        const products = payload.resources?.results?.products || [];
        const searchUrl = `/search?q=${encodeURIComponent(query)}&type=product`;
        target.innerHTML = products.length
          ? `<div class="search-results__summary"><p>${products.length} results</p><a href="${searchUrl}">View all results</a></div><div>${products.map((product) => `<article class="predictive-card"><a href="${escapeHtml(product.url)}">${product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}">` : ""}<span>${escapeHtml(product.title)}</span></a></article>`).join("")}</div>`
          : `<div class="search-results__empty"><p>No matching pieces found.</p><a class="button button--outline" href="${searchUrl}">Search all products</a></div>`;
        target.hidden = false;
      } catch (error) {
        if (error.name === "AbortError") return;
        target.innerHTML = `<div class="search-results__empty"><p>Search is temporarily unavailable.</p><a class="button button--outline" href="/search">Open search page</a></div>`;
        target.hidden = false;
      } finally {
        target.setAttribute("aria-busy", "false");
      }
    }, 220);
    searchTimers.set(input, timer);
  });

  function openWhatsApp(button) {
    const form = button.closest("form");
    if (!form) return;
    const fields = new FormData(form);
    const message = [
      "Hello Rustic Jewel Co, I would like to send an inquiry.",
      `Name: ${fields.get("contact[name]") || ""}`,
      `Email: ${fields.get("contact[email]") || ""}`,
      `Category / request: ${fields.get("contact[category]") || ""}`,
      `Quantity / timing: ${fields.get("contact[timing]") || ""}`,
      `Details: ${fields.get("contact[body]") || ""}`
    ].join("\n");
    window.open(`https://wa.me/${button.dataset.whatsappNumber}?text=${encodeURIComponent(message)}`, "_blank", "noopener,noreferrer");
  }

  document.addEventListener("click", async (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const variantButton = target.closest('[data-variant-button]');
    if (variantButton) {
      event.preventDefault();
      const productRoot = variantButton.closest('.product-detail') || document;
      const variantSelect = $('[data-variant-select]', productRoot);
      if (!variantSelect || variantButton.disabled) return;
      variantSelect.value = variantButton.dataset.variantId || "";
      variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    const mediaButton = target.closest('[data-media-button]');
    if (mediaButton) {
      event.preventDefault();
      const productRoot = mediaButton.closest('.product-detail') || document;
      setActiveProductMedia(productRoot, mediaButton.dataset.mediaId);
      return;
    }

    const drawerOpen = target.closest('[data-drawer-open]');
    if (drawerOpen) {
      openLayer(`[data-drawer="${drawerOpen.dataset.drawerOpen}"]`, drawerOpen);
      if (drawerOpen.dataset.drawerOpen === "bag") getCart().then(renderCart).catch(() => setCartStatus("Unable to refresh bag", true));
      return;
    }
    const panelOpen = target.closest('[data-panel-open]');
    if (panelOpen) { openLayer(`[data-panel="${panelOpen.dataset.panelOpen}"]`, panelOpen); return; }
    if (target.closest('[data-drawer-close], [data-panel-close], [data-overlay]')) { closeLayers(); return; }

    const menuToggle = target.closest('[data-menu-toggle]');
    if (menuToggle) {
      const menuCategories = $('[data-menu-categories]', menuToggle.parentElement || document);
      const expanded = menuToggle.getAttribute("aria-expanded") === "true";
      menuToggle.setAttribute("aria-expanded", String(!expanded));
      if (menuCategories) menuCategories.hidden = expanded;
      $("svg, [data-lucide]", menuToggle)?.classList.toggle("is-open", !expanded);
      return;
    }

    const announcementPrev = target.closest('[data-announcement-prev]');
    if (announcementPrev) { event.preventDefault(); event.stopPropagation(); rotateAnnouncement(announcementPrev, -1); return; }
    const announcementNext = target.closest('[data-announcement-next]');
    if (announcementNext) { event.preventDefault(); event.stopPropagation(); rotateAnnouncement(announcementNext, 1); return; }

    const copyButton = target.closest('[data-copy-code]');
    if (copyButton) { await copyCode(copyButton); return; }

    const reviewButton = target.closest('[data-review-scroll]');
    if (reviewButton) {
      event.preventDefault();
      event.stopPropagation();
      scrollReviews(reviewButton);
      return;
    }

    const filterToggle = target.closest('[data-filter-toggle]');
    if (filterToggle) {
      const filterRow = $('[data-filter-row]');
      const expanded = filterToggle.getAttribute("aria-expanded") === "true";
      filterToggle.setAttribute("aria-expanded", String(!expanded));
      if (filterRow) filterRow.hidden = expanded;
      return;
    }

    const accordionButton = target.closest('[data-accordion]');
    if (accordionButton) {
      const panel = accordionButton.nextElementSibling;
      const expanded = accordionButton.getAttribute("aria-expanded") === "true";
      accordionButton.setAttribute("aria-expanded", String(!expanded));
      if (panel) panel.hidden = expanded;
      $("svg, [data-lucide]", accordionButton)?.classList.toggle("is-open", !expanded);
      return;
    }

    const whatsappButton = target.closest('[data-whatsapp-form]');
    if (whatsappButton) openWhatsApp(whatsappButton);
  });

  document.addEventListener("change", (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const sortSelect = target.closest('[data-sort-select]');
    if (sortSelect) { sortSelect.form?.submit(); return; }
    const variantSelect = target.closest('[data-variant-select]');
    if (variantSelect) updateVariant(variantSelect);
  });

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const hero = $('[data-hero]');
  if (hero && !reducedMotion) {
    const image = $("img", hero);
    const copy = $$('[data-hero-copy]', hero);
    hero.animate([{ clipPath: "inset(0 0 0 100%)", opacity: 1 }, { clipPath: "inset(0 0 0 0)", opacity: 1 }], { duration: 1350, delay: 80, fill: "both", easing: "cubic-bezier(.22,1,.36,1)" });
    image?.animate([{ transform: "scale(1.08)" }, { transform: "scale(1)" }], { duration: 1900, delay: 80, fill: "both", easing: "cubic-bezier(.22,1,.36,1)" });
    copy.forEach((element, index) => element.animate([{ opacity: 0, transform: "translateY(24px)" }, { opacity: 1, transform: "translateY(0)" }], { duration: 720, delay: 620 + index * 90, fill: "both", easing: "cubic-bezier(.22,1,.36,1)" }));
  }

  const revealItems = $$('[data-reveal]');
  if (reducedMotion || !("IntersectionObserver" in window)) revealItems.forEach((item) => item.classList.add("is-visible"));
  else {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    }), { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  }

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target instanceof Element ? event.target : document;
    $$('[data-reveal]', root).forEach((item) => item.classList.add("is-visible"));
    initializeVariantPickers(root);
    refreshIcons();
    window.requestAnimationFrame(refreshIcons);
  });

  document.addEventListener("shopify:block:select", (event) => {
    if (!(event.target instanceof Element)) return;
    const selectedBlock = event.target;
    selectedBlock.classList.add("is-visible");
    if (selectedBlock.matches('[data-announcement]')) {
      $$('[data-announcement]', selectedBlock.closest('[data-announcements]') || document).forEach((item) => { item.hidden = item !== selectedBlock; });
    }
    selectedBlock.scrollIntoView({ block: "center", inline: "center", behavior: "smooth" });
    refreshIcons();
    window.requestAnimationFrame(refreshIcons);
  });

  document.addEventListener("shopify:inspector:activate", () => document.body.classList.add("is-inspect-mode"));
  document.addEventListener("shopify:inspector:deactivate", () => document.body.classList.remove("is-inspect-mode"));

  initializeVariantPickers();
  refreshIcons();
  window.addEventListener("load", refreshIcons, { once: true });
  window.setTimeout(refreshIcons, 250);
})();
